export default "__VITE_ASSET__42b03d23__"